import { createStore } from 'vuex'

export default createStore({
  state: {
    isLogin: false,
    userInfo: null
  },
  mutations: {
    setLoginState(state, status) {
      state.isLogin = status
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo
    }
  },
  actions: {
    login(context, userInfo) {
      context.commit('setLoginState', true)
      context.commit('setUserInfo', userInfo)
    },
    logout(context) {
      context.commit('setLoginState', false)
      context.commit('setUserInfo', null)
    }
  },
  modules: {},
});
